import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Icon } from "@iconify/react";
import Breadcrumb from "../../components/Breadcrumb";
import PageHeader from "../../components/common/PageHeader";
import ViewProductAffiliate from "../../components/products/ViewProductAffiliate";
import MasterLayout from "../../masterLayout/MasterLayout";
import AffiliatesServices from "../../services/api/affiliates";

const ProductsAffiliates = () => {
  const [affiliatesProducts, setAffiliatesProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getAffiliatesProducts = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await AffiliatesServices.getAffiliatesProducts();

      if (response && response.success) {
        // Filtrar apenas afiliados (role_type === 'affiliate')
        // Gerentes (role_type === 'manager') vão aparecer em "Produtos que Gerencio"
        const onlyAffiliates = (response.data || []).filter(
          item => item.role_type === 'affiliate'
        );
        setAffiliatesProducts(onlyAffiliates);
      } else {
        setError('Resposta inválida da API');
        setAffiliatesProducts([]);
      }
    } catch (error) {
      console.error("Erro ao buscar produtos que promovo:", error);
      setError(error.message || 'Erro ao carregar produtos que promovo');
      setAffiliatesProducts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Memoizar o componente ViewProductAffiliate
  const viewProductComponent = useMemo(() => (
    <ViewProductAffiliate affiliatesProducts={affiliatesProducts} />
  ), [affiliatesProducts]);

  useEffect(() => {
    getAffiliatesProducts();
  }, [getAffiliatesProducts]);

  if (loading) {
    return (
      <MasterLayout>
        <Breadcrumb title="Produtos que Promovo" />
        <PageHeader
          icon="mdi:share-variant"
          title="Produtos que Promovo"
          subtitle="Gerencie os produtos que você promove como afiliado"
        />
        <div className="text-center py-5">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="text-muted">Carregando produtos que promovo...</p>
        </div>
      </MasterLayout>
    );
  }

  if (error) {
    return (
      <MasterLayout>
        <Breadcrumb title="Produtos que Promovo" />
        <PageHeader
          icon="mdi:share-variant"
          title="Produtos que Promovo"
          subtitle="Gerencie os produtos que você promove como afiliado"
        />
        <div className="alert alert-danger" role="alert">
          <h6 className="alert-heading">Erro ao carregar produtos que promovo</h6>
          <p className="mb-0">{error}</p>
          <button 
            className="btn btn-outline-danger btn-sm mt-2"
            onClick={getAffiliatesProducts}
          >
            Tentar novamente
          </button>
        </div>
      </MasterLayout>
    );
  }

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Produtos que Promovo" />

        {/* Header Section */}
        <PageHeader
          icon="mdi:share-variant"
          title="Produtos que Promovo"
          subtitle="Gerencie os produtos que você promove como afiliado"
        />

        {/* ViewProduct */}
        {viewProductComponent}
      </MasterLayout>
    </>
  );
};

export default ProductsAffiliates;
